// Dutch

export default {

  component: {
    jobAdList: {
      title: 'Vacatures openen',
      jobs: 'jobs',
      noJobAds: 'Er zijn momenteel geen openstaande vacatures.',
    },

    jobAdCard: {
      openUntil: date => `Open until ${date}`,
    },

    jobAdGreetings: {
      thankYou: 'Hartelijk dank.',
      readyInfo: 'Uw sollicitatie is ontvangen en de recruiter neemt z.s.m. contact met u op.',
      luck: 'Veel succes!',
    },

    jobAdSeeYou: {
      title: 'Hartelijk dank.',
      description: 'Uw sollicitatie is opgeslagen en we hebben een link verzonden zodat u er later mee door kunt gaan.',
    },

    unpublished: {
      title: 'Niet gepubliceerd',
      info: 'De vacature is niet nog gepubliceerd.',
    },
  },

  page: {},

}
